var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-onboard',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"template",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('m-card-onboard-story',{attrs:{"item":item,"index":index}})]}}])},'m-onboard',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }